// for Android and iOS firebase log events
// https://firebase.google.com/docs/analytics/ios/webview
// 2018.08.29 Wildmud Aleiku

export default new class WWebView {
	
	openURL(url) {
	  if (!url) {
	    return;
	  }

	  if (window.AnalyticsWebInterface) {
	    // Call Android interface
	    window.AnalyticsWebInterface.logEvent(url, JSON.stringify({
	    	command: 'open_url',
	        url: url
	    }));
	  } else if (window.webkit
	      && window.webkit.messageHandlers
	      && window.webkit.messageHandlers.firebase) {
	    // Call iOS WKMessageHandlers interface
	    const message = {
	      command: 'openURL',
	      url: url
	    };
	    window.webkit.messageHandlers.firebase.postMessage(message);
	  } 
	  else if (window.WWebViewHandler) {
	    // Call iOS WWebViewHandler interface
	    const message = {
	      command: 'openURL',
	      url: url
	    };
	    window.WWebViewHandler.postMessage(message);
	  } else {
	    // No Android or iOS interface found
	    console.log("No native APIs found. " + url);
	    window.location.href = url
	  }
	}

	goBack() {

	  if (window.AnalyticsWebInterface) {
	    // Call Android interface
	    window.AnalyticsWebInterface.logEvent('goBack', JSON.stringify({
	    	command: 'goBack'
	    }));
	  } else if (window.webkit
	      && window.webkit.messageHandlers
	      && window.webkit.messageHandlers.firebase) {
	    // Call iOS WKMessageHandlers interface
	    const message = {
	      command: 'goBack'
	    };
	    window.webkit.messageHandlers.firebase.postMessage(message);
	  } 
	  else if (window.WWebViewHandler) {
	    // Call iOS WWebViewHandler interface
	    const message = {
	      command: 'goBack'
	    };
	    window.WWebViewHandler.postMessage(message);
	  } else {
	    console.log("No native APIs found. ");
	  }
	}

	popToHome() {

	  if (window.AnalyticsWebInterface) {
	    // Call Android interface
	    window.AnalyticsWebInterface.logEvent('popToHome', JSON.stringify({
	    	command: 'popToHome'
	    }));
	  } else if (window.webkit
	      && window.webkit.messageHandlers
	      && window.webkit.messageHandlers.firebase) {
	    // Call iOS WKMessageHandlers interface
	    const message = {
	      command: 'popToHome'
	    };
	    window.webkit.messageHandlers.firebase.postMessage(message);
	  } 
	  else if (window.WWebViewHandler) {
	    // Call iOS WWebViewHandler interface
	    const message = {
	      command: 'popToHome'
	    };
	    window.WWebViewHandler.postMessage(message);
	  } else {
	    console.log("No native APIs found. ");
	  }
	}

}()


// WEBPACK FOOTER //
// ./src/helpers/wwebview.js